import { render, staticRenderFns } from "./BranchDelete.vue?vue&type=template&id=de31dbc2&scoped=true&"
import script from "./BranchDelete.vue?vue&type=script&lang=js&"
export * from "./BranchDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de31dbc2",
  null
  
)

export default component.exports